import { TCaEventDataSelector, TDataFrame, TDataSelectors, TFramedData } from './types';

const createObject = <T extends object, TValue>(
  obj: T,
  fn: (key: keyof T) => TValue,
): { [Property in keyof T]: TValue } => {
  const entries = Object.keys(obj).map(key => {
    return [key, fn(key as keyof T)];
  });

  return Object.fromEntries(entries) as { [Property in keyof T]: TValue };
};

export const createDataFrame = <T extends object>(data: T): TDataFrame<T> => {
  return createObject(data, () => null) as TDataFrame<T>;

  // const entries = Object.keys(data).map(key => [key as keyof T, null]);

  // return Object.fromEntries(entries);
};

export const getFramedData = <TData>(dataFrame: TDataFrame<TData>, partialData: Partial<TData>): TFramedData<TData> => {
  return {
    ...dataFrame,
    ...partialData,
  };
};

export const createLazySelector = <T>(
  selectors: TDataSelectors<T>,
  partialData: Partial<T>,
): TCaEventDataSelector<T> => {
  const dataFrame = createDataFrame(selectors);
  const framedData = getFramedData<T>(dataFrame, partialData);

  return state => {
    return createObject(dataFrame, key => framedData[key as keyof T] || selectors[key as keyof T](state)) as ReturnType<
      TCaEventDataSelector<T>
    >;

    // const entries = Object.keys(dataFrame).map(key => {
    //   return [key, framedData[key as keyof T] || selectors[key as keyof T](state)];
    // });
    //
    // return Object.fromEntries(entries);
  };
};
